import React from "react";

const ViewBlog = ({blog,onClose}) => {
return(
    <div className="fixed top-0 left-0 w-full h-full bg-color bg-opacity-50 flex items-center justify-center">
         
          <div className="bg-color p-8 rounded-lg shadow-lg border-4 border-white border-solid">

          <div className="bg-color text-white p-8 rounded-md">
          <h2 className="text-xl font-bold mb-4">Blog Details</h2>

          <p><strong>ID: </strong>{blog.id}</p>
          <p><strong>Blogger Name: </strong>{blog.bloggerName}</p>
          <p><strong>Topic Name: </strong>{blog.topicName}</p>
          <p><strong>Role Name: </strong>{blog.rolename}</p>
          <p><strong>Description: </strong>{blog.description}</p>
          <p><strong>Date: </strong>{blog.date}</p>

          <button className="bg-black text-white px-4 py-2 rounded-md mt-4" onClick={onClose}>Close</button>

</div>
</div>
</div>
)
}

export default ViewBlog;